/**
 * We'll load the axios HTTP library which allows us to easily issue requests
 * to our Laravel back-end. This library automatically handles sending the
 * CSRF token as a header based on the value of the "XSRF" token cookie.
 */

import axios from "axios"
import Echo from "laravel-echo"
import _ from "lodash"
import Pusher from "pusher-js"

window._ = _

window.axios = axios

window.axios.defaults.headers.common["X-Requested-With"] = "XMLHttpRequest"

axios.interceptors.response.use(
    (response) => response,
    async (error) => {
        const config = error.config ?? {}

        if (! axios.isCancel(error) && ! error.response && ! config._retried) {
            const method = (config.method ?? "get").toLowerCase()
            const isIdempotent = method === "get" || method === "head" || method === "options"

            if (isIdempotent || config._retryOnNetworkError === true) {
                config._retried = true
                await new Promise((resolve) => setTimeout(resolve, 500))

                return axios.request(config)
            }
        }

        if (error.response?.status === 401) {
            window.location.href = "/login"
            return new Promise(() => {})
        }

        return Promise.reject(error)
    },
)

/**
 * Echo exposes an expressive API for subscribing to channels and listening
 * for events that are broadcast by Laravel. Echo and event broadcasting
 * allows your team to easily build robust real-time web applications.
 */

window.Pusher = Pusher

window.Echo = new Echo({
    broadcaster: "pusher",
    key: import.meta.env.VITE_PUSHER_APP_KEY,
    cluster: import.meta.env.VITE_PUSHER_APP_CLUSTER,
    forceTLS: true,
})
